import axios from 'axios';

const getEntidade = () => axios.get('/entidades');

export default {
  getEntidade,
};
